export const DATE_FORMATS = {
  default: "d MMM yyyy",
  defaultWithTime: "d MMM yyyy 'at' H:mm",
  onlyTime: "H:mm",
  onlyDay: "d",
} as const;
